// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"295d1446","115":"ac66d487","453":"e62aee44","629":"e3213270","853":"cc2b0d55","989":"3ce4e79b"}[chunkId] + ".chunk.js";
};